import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import styles from './styles';
import EquipmentGroupTab from './EquipmentGroupTab';
import EquipmentTab from './EquipmentTab';
import PF2MTabs from '~/components/PF2MTabs';

const EquipmentGroup = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const { t: translate } = useTranslation();

  const tabs = [
    { key: 0, label: translate('common:EquipmentGroup') },
    { key: 1, label: translate('common:Equipment') },
  ];

  const handleChange = (event, value) => {
    setSelectedTab(value);
  };

  return (
    <>
      <PF2MTabs
        value={selectedTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
      >
        {tabs}
      </PF2MTabs>
      {selectedTab === 0 ? (<EquipmentGroupTab />) : null}
      {selectedTab === 1 ? (<EquipmentTab />) : null}
    </>
  );
};

export default withStyles(styles)(EquipmentGroup);
